import { render, staticRenderFns } from "./RolesTableLoading.vue?vue&type=template&id=2e269ded&scoped=true&"
import script from "./RolesTableLoading.vue?vue&type=script&lang=js&"
export * from "./RolesTableLoading.vue?vue&type=script&lang=js&"
import style0 from "./RolesTableLoading.vue?vue&type=style&index=0&id=2e269ded&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e269ded",
  null
  
)

export default component.exports